import { render, staticRenderFns } from "./MobAdTab.vue?vue&type=template&id=b1a29c5a"
import script from "./MobAdTab.vue?vue&type=script&lang=js"
export * from "./MobAdTab.vue?vue&type=script&lang=js"
import style0 from "./MobAdTab.vue?vue&type=style&index=0&id=b1a29c5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports